import { Chip, Stack, Typography } from '@lingoda/ui';
import { trans } from '@lingoda/i18n';
import { assert } from '@lingoda/utils';
import { ClassType } from '@lingoda/monolith-graphql';
import { getLessonSubtitle } from '@lingoda/booking-ui';
import { ClassTime, Participants, Teacher } from './components';
import type { PostCheckoutClass } from '../../types';

interface BookedClassInformationProps {
    classItem: PostCheckoutClass;
}

export const BookedClassInformation = ({ classItem }: BookedClassInformationProps) => {
    const { module, lesson, startDateIso, endDateIso, students, teacher, type } = classItem;

    assert(lesson, 'Lesson should exist');
    const { units, label, title } = lesson;
    const moduleName = module.name;
    const chapterNumber = units?.[0]?.chapter ?? 1;
    const classLessonSubtitle = getLessonSubtitle(moduleName, chapterNumber, label);
    const classTypeLabel =
        type === ClassType.Individual
            ? trans('private-class', {}, 'student-common')
            : trans('group-class', {}, 'student-common');

    return (
        <Stack spacing={3} p={3}>
            <Chip color="promotion" label={classTypeLabel} sx={{ alignSelf: 'flex-start' }} />
            <Stack spacing={1}>
                <Typography variant="h2">{title}</Typography>
                <Typography
                    variant="subtitle2"
                    htmlColor="text.secondary"
                    textTransform="uppercase"
                >
                    {classLessonSubtitle}
                </Typography>
            </Stack>
            <ClassTime startDateIso={startDateIso} endDateIso={endDateIso} />
            {students.length > 0 && <Participants participants={students} />}
            <Teacher teacher={teacher} />
        </Stack>
    );
};
